var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper-404"},[_c('c-empty',{attrs:{"text":"抱歉，页面加载失败！"}}),_c('el-button',{attrs:{"plain":""},on:{"click":_setup.backHome}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }